import pricingPlanV2Service from './ws';

export default pricingPlanV2Service;